import { FunctionComponent, useMemo } from 'react';
import { Offer } from '@shared/types';
import { PublicEducator, PublicOnDemandCourse } from '@cademy-package/sdk-component-types';
import { getBookingUrl } from '../../../../../../services/getBookingUrl';
import { BookButton } from '../BookButton';
import { useIsEmbed } from '../../../../../../contexts/AppContext/useIsEmbed';

type OnDemandBookButtonProps = {
    course: PublicOnDemandCourse;
    educator: PublicEducator;
    membershipRequired: boolean;
};

const getCourseOffersWithPrice = (offers: Array<Offer>): Array<Offer> => {
    return offers.filter((offer: Offer) => {
        return offer.price && offer.price > 0;
    });
};

export const OnDemandBookButton: FunctionComponent<OnDemandBookButtonProps> = ({
    course,
    educator,
    membershipRequired,
}) => {
    const isEmbed: boolean = useIsEmbed();
    const buttonLabel: string = useMemo(() => {
        if (course.offers) {
            if (getCourseOffersWithPrice(course.offers).length > 0) {
                return 'Buy';
            }
        }
        return course.price && course.price > 0 ? 'Buy' : 'Enrol';
    }, [course.offers, course.price]);

    return (
        <BookButton
            href={
                membershipRequired
                    ? '#'
                    : getBookingUrl({
                          courseSlug: course.slug,
                          courseType: course.type,
                          educatorSlug: educator.slug,
                          isEmbed,
                      })
            }
            preset={membershipRequired ? 'disabled' : 'primary'}
            buttonLabel={buttonLabel}
        />
    );
};
